import { scrollToBottom } from '../../../../@helpers';
import React from 'react';
import Message from './Message';
import QuickReplies from './QuickReplies';
class MessageList extends React.Component {
    conversationElement = React.createRef()

    componentDidUpdate(){
      scrollToBottom(this.conversationElement)
    }
    
    render(){
      const { messages } = this.props
      const components = {
        'bot': Message,
        'user': Message,
        'system': Message,
        'quickreplies': QuickReplies,
      }

      return (
          <ul
            ref={ this.conversationElement }
            className="chatbot_conversation" 
            data-active={ messages.length > 0 ? true : false }
          >
            { messages && messages.map((message, index) => {
              const SpecificComponent = components[message.speaks];
              return SpecificComponent && <li key={ `message-${ index }` } className={ `conversation_item ${message.speaks}` }><SpecificComponent message={ message } { ...this.props } /></li>;
            }) }
          </ul>
      )
    }
  }

export default MessageList